exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".navbar{z-index:2;box-shadow:0 3px 6px rgba(0,0,0,.15)}.product-landing{overflow:hidden}@media(min-width: 992px){.product-landing .video-button{margin-left:-7rem}}.product-landing .video-button button{font-size:1.5rem;text-transform:none}@media(max-width: 575px){.product-landing .video-button button{font-size:1rem}}.product-landing .video-button button svg{margin:10px;width:2.5rem;height:2.5rem}.term-landing .about p{width:auto}@media(min-width: 768px){.term-landing .about p{width:1020px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./src/components/LandingPages/ProductLandingPage.scss
// module id = 8024
// module chunks = 13